"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const timeoutPromise_1 = __importStar(require("./timeoutPromise"));
function default_1(fn, condition, options = {}) {
    let timeout;
    let abort = false;
    const polling = () => __awaiter(this, void 0, void 0, function* () {
        const { delay = 1000, maxIterations, timeout: timeoutMs } = options;
        let i = 0;
        let promiseDidTimeout = false;
        let res;
        function resolveFn() {
            return __awaiter(this, void 0, void 0, function* () {
                promiseDidTimeout = false;
                try {
                    return yield (timeoutMs !== undefined ? (0, timeoutPromise_1.default)(fn(), timeoutMs) : fn());
                }
                catch (e) {
                    if (e instanceof timeoutPromise_1.TimeoutPromiseError)
                        promiseDidTimeout = true;
                    else
                        throw e;
                }
            });
        }
        res = yield resolveFn();
        while (!abort && (promiseDidTimeout || condition(res))) {
            if (i === maxIterations)
                throw new Error("Polling executed the maximum number iterations");
            yield new Promise((resolve) => {
                timeout = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                    i++;
                    res = yield resolveFn();
                    resolve();
                }), delay);
            });
        }
        return res;
    });
    const result = polling();
    result.abort = () => {
        abort = true;
        clearTimeout(timeout);
    };
    return result;
}
exports.default = default_1;
